import "react-step-progress-bar/styles.css";
import { ALL_STEPS_LIST_CORPORATE } from "../../containers/Form/constants";
import { useTranslation } from 'react-i18next';

import './style.css';

const Progress = ({ currentStep }) => {

    const { i18n } = useTranslation();

    const getStepLabel = (step) => {
        // Define your step labels here
        const stepLabels = {
            STEP_1: `Basic Information`,
            STEP_2: `Director Details`,
            STEP_3: `Ultimate Beneficial Owner`,
            STEP_4: `Authorized Signatory Section`,
            STEP_5: `Financial Details`,
        };
    
        return stepLabels[step] || '';
    };

    return (
        <div className={`flex center ${ (i18n.language === 'de' || i18n.language === 'fa') ? 'flex-row-reverse' : ''}`}>
        {ALL_STEPS_LIST_CORPORATE.map((step, index) => (
            <div
            key={index}
            className={`steps ${step.toLowerCase()} ${currentStep >= index + 1 ? 'darkStep' : 'lightStep'}`}
        >
            {getStepLabel(step)}
        </div>
        ))}
    </div>
    );
};

export default Progress;
